import React from 'react';

function Blockf({ language }) {
  // Content for both English and Hindi
  const content = {
    en: [
      {
        title: "Abhigyan Shakuntalam",
        image: "images/main-attractions/block-f/block-f-1.png",
        description: `The story of Shakuntala will come alive highlighting the virtues of patience, forgiveness, and the resilience of the human spirit. Discover how India came to be known as "Bharatavarsha” named after Bharata- a brave and powerful ruler. `,
      },
      {
        title: "Saraswati",
        image: "images/main-attractions/block-f/block-f-2.png",
        description: `In this Sound and Light Show, Goddess Saraswati herself appears as the narrator — the eternal embodiment of knowledge, music, and creation. She takes the audience on a timeless journey — from the dawn of creation through the Vedas, Puranas, and the Mahabharata, past the banks where the Indus–Saraswati Civilization once flourished, to the sacred confluence at Prayag Sangam, where her presence is still felt during the Kumbh Mela. Her voice embodies the eternal spirit of India — where culture, philosophy, and faith flow as one unbroken stream.`,
      },
      // Add other items here...
    ],
    hi: [
      {
        title: "अभिज्ञान शाकुंतलम",
        image: "images/main-attractions/block-f/block-f-1.png",
        description: `शकुंतला की कहानी धैर्य, क्षमा और मानवीय भावना के लचीलेपन के गुणों को उजागर करते हुए जीवंत हो जाएगी। जानें कि कैसे भारत को "भारतवर्ष" के नाम से जाना जाने लगा, जिसका नाम भरत के नाम पर रखा गया - एक बहादुर और शक्तिशाली शासक। `,        
      },
      {
        title: "सरस्वती",
        image: "images/main-attractions/block-f/block-f-2.png",
        description: `इस साउंड एंड लाइट शो में देवी सरस्वती स्वयं वक्ता बनकर प्रकट होती हैं — ज्ञान, संगीत और सृजन की आदि शक्ति के रूप में। वह दर्शकों को युगों की यात्रा पर ले जाती हैं — सृष्टि से लेकर वेदों, पुराणों, और महाभारत तक, जहाँ उनकी ही पवित्र धारा के तट पर सिन्धु–सरस्वती सभ्यता फली-फूली, और जहाँ आज भी प्रयाग के संगम में कुम्भ के समय उनकी उपस्थिति अनुभव की जाती है। उनकी वाणी भारत की उस सनातन धारा को अभिव्यक्त करती है — जहाँ संस्कृति, दर्शन और आस्था एकाकार हैं।`,
      },
      // Add other items here...
    ],
  };

  return (
    <div className="main_attractions_list">
      {content[language].map((item, index) => (
        <div className="list_item" id={`ma-blockf-${index}`} key={index}>
          <div className="attraction_image">
            <img src={item.image} alt={item.title} />
          </div>
          <div className="attranction_details">
            <h3>{item.title}</h3>
            <p>{item.description}</p>
            {item.label && <span className="main-attraction-label">{item.label}</span>}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Blockf;
